import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DuvidasFrequentesPage } from 'src/app/pages/duvidas-frequentes-page/duvidas-frequentes-page.component';
import { LoaderModule } from '../loader/loader/loader.module';
import { PartialModule } from '../partial/partial.module';
import { DuvidaItemComponent } from 'src/app/components/duvida/duvida-item/duvida-item.component';
import { DuvidaFrequenteRoutingModule } from './duvida-frequente-routing.module';
import { DirectivesModule } from '../directives/directives/directives.module';
import { PipeModule } from '../pipe/pipe.module';

@NgModule({
  declarations: [
    DuvidasFrequentesPage,
    DuvidaItemComponent
  ],
  exports: [
    DuvidasFrequentesPage,
    DuvidaItemComponent
  ],
  imports: [
    CommonModule,
    LoaderModule,
    PartialModule,
    DuvidaFrequenteRoutingModule,
    DirectivesModule,
    PipeModule
  ]
})
export class DuvidaFrequenteModule { }
